import type { MotionValue } from "framer-motion";
import landscapeForegroundEvening from "../../../assets/landscape-foreground-evening.webp?inline";
import landscapeForegroundHills from "../../../assets/landscape-foreground-hills.webp?inline";
import { CrossfadeParallaxLayer } from "../../../shared/landscape/crossfade-parallax-layer";

type TLandscapeForegroundProps = {
	y: MotionValue<number>;
	eveningOpacity: MotionValue<number>;
};

export function LandscapeForeground({ y, eveningOpacity }: TLandscapeForegroundProps) {
	return (
		<CrossfadeParallaxLayer
			y={y}
			eveningOpacity={eveningOpacity}
			daySrc={landscapeForegroundHills}
			eveningSrc={landscapeForegroundEvening}
			className="absolute z-[4] pointer-events-none select-none inset-x-0 bottom-[-985px] h-[calc(30%+720px)] max-md:left-auto max-md:right-[-60%] max-md:bottom-[-750px] max-md:w-[220%] max-md:h-[calc(34%+500px)]"
			scale={1}
		/>
	);
}
